import { healthResponseSchema, type HealthResponse } from '@koderek/shared';
import { Alert, Loader, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { ApiError, apiGet } from '../../api/client';
import { t } from '../../texts/pl';

async function fetchHealth(): Promise<HealthResponse> {
  try {
    return await apiGet('/health', healthResponseSchema);
  } catch (error) {
    // 503 z poprawną treścią = serwer działa, baza nie.
    if (error instanceof ApiError && error.status === 503) {
      return healthResponseSchema.parse(error.body);
    }
    throw error;
  }
}

export function SystemStatus() {
  const { data, isPending, isError } = useQuery({ queryKey: ['health'], queryFn: fetchHealth, retry: false });

  if (isPending) {
    return (
      <Text c="dimmed" role="status">
        <Loader size="xs" mr="xs" />
        {t.status.checking}
      </Text>
    );
  }
  if (isError) {
    return (
      <Alert color="red" title={t.status.title} role="alert">
        {t.status.unreachable}
      </Alert>
    );
  }
  const ok = data.database === 'up';
  return (
    <Alert color={ok ? 'green' : 'orange'} title={t.status.title} role="status">
      {ok ? t.status.ok : t.status.databaseDown}{' '}
      <Text span c="dimmed" size="sm">
        ({t.status.version}: {data.version})
      </Text>
    </Alert>
  );
}
